<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t('advancesalesreport') }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getAdvanceSalesReportsSelectedCinema && getAdvanceSalesReportsSelectedCinema.length>0? 'shift-up':''"
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>

              <b-dropdown
                :text="getAdvanceSalesReportsSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="onAdvanceSalesReportDropDownHandler({ event: $event, name:'isCinema',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getAdvanceSalesReportsSelectedMovie ? 'shift-up':''"
              >{{ $tc('movie', 1) }}</label>
              <b-dropdown
                :text="getAdvanceSalesReportsSelectedMovie"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorsMasterMovieList"
                  :key="dropdownIndex"
                  @click="onAdvanceSalesReportDropDownHandler({ event: $event, name:'MasterMovie',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.movie_title }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button class="btn-blue-lg w-100">{{ $tc('Get Report') }}</button>
          </div>
        </div>

        <div class="swc-report">
          <table class="swc-report-table" border="1">
            <thead>
              <tr>
                <th>Items</th>
                <th>Unit</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="p-0"></td>
                <td class="p-0">
                  <table class="w-100">
                    <tr>
                      <td>Qty Sold</td>
                      <td class="d-flex align-items-center">
                        <img
                          src="@/assets/img/icons/sort.svg"
                          class="cursor-pointer"
                          width="15px"
                          height="20px"
                        />Net Price
                      </td>
                      <td>Std Profit</td>
                      <td class="d-flex align-items-center">
                        <img
                          src="@/assets/img/icons/sort.svg"
                          class="cursor-pointer"
                          width="15px"
                          height="20px"
                        />Std Profit %
                      </td>
                    </tr>
                  </table>
                </td>
                <td class="p-0">
                  <table class="w-100">
                    <tr>
                      <td>Net Sales</td>
                      <td>Sales Price</td>
                      <td>Net Profit %</td>
                      <td>Profit Mix %</td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td class="p-0">Large Cheese Comdo</td>
                <td class="p-0">
                  <table class="w-100">
                    <tr>
                      <td>-1</td>
                      <td>120.00</td>
                      <td>104.82</td>
                      <td>87.35</td>
                    </tr>
                  </table>
                </td>
                <td class="p-0">
                  <table class="w-100">
                    <tr>
                      <td>-120.00</td>
                      <td>-0.01</td>
                      <td>91.25</td>
                      <td>0.01</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
export default {
  data() {
    return {
         Cinemas:[],
      isRoleID:true
    };
  },
  computed: {
    ...mapGetters([
      "getCinemasList",
      "getAdvanceSalesReportsSelectedCinema",
      "getAdvanceSalesReportsSelectedMovie",
      "getDistributorsMasterMovieList"
      //"getRecipeReports",

      // EXCEL
      //"getRecipeReportsExcelFileName",
      // PDF
      //"getRecipeReportsPDFFileName"
    ])
  },
  mounted() {
     let roleid = this.secureStore.get("USINFO").role_id;
        if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);

    // this.fetchCinemasList({ cinemaId });

    this.fetchDistributorsActiveMasterMovie();
  },
  methods: {
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
    //  let payload = null
    //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
       MasterService.GetCinemas({cine_id: cine_id})
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            // this.CinemasCopy = data.Records;
             this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                
               
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };
                
                // this.onSelectCinema(null,cinema);
                this.onAdvanceSalesReportDropDownHandler({ name:'isCinema',selectedItem: {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id
                } })
              
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "onAdvanceSalesReportDropDownHandler",
      "fetchDistributorsActiveMasterMovie"
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/advanceSalesReport.vue